export const GET_ITEMS = " GET_ITEMS";
export const ADD_TO_CARTS = " ADD_TO_CARTS";
export const GET_PREVIOUS_CARTS = " GET_PREVIOUS_CARTS";
export const GET_All_PRODUCTS = " GET_All_PRODUCTS";
export const DELETE_ITEM = " DELETE_ITEM";
export const CLEAR_CART = " CLEAR_CART";
export const FILTER_PRODUCT = " FILTER_PRODUCT";
export const INCREASE_CART_ITEM = " INCREASE_CART_ITEM";
export const DECREASE_CART_ITEM = " DECREASE_CART_ITEM";
export const GET_TOTAL = " GET_TOTAL";
export const GET_CART_LENGTH = " GET_CART_LENGTH";
export const SET_ALERT = " SET_ALERT";
export const CHANGE_LOCATION = " CHANGE_LOCATION";
export const REMOVE_ALERT = " REMOVE_ALERT";
//jjkj
export const REGISTER_SUCCESS = " REGISTER_SUCCESS";
export const REGISTER_FAIL = " REGISTER_FAIL";
export const USER_LOADED = " USER_LOADED";
export const AUTH_ERROR = " AUTH_ERROR";
export const LOGIN_SUCCESS = " LOGIN_SUCCESS";
export const LOGIN_FAIL = " LOGIN_FAIL";
export const LOGOUT = " LOGOUT";
export const CLEAR_ERRORS = " CLEAR_ERRORS";
